import { IMG, VALUES, TEAM } from "../data/site";
import { PageHero, Section, Overline, Btn } from "../components/site/bits";
import { Reveal, Stagger, StaggerItem } from "../components/site/motion";

export default function About() {
  return (
    <>
      <PageHero overline="About Us" lines={["Who we are,", "and why we're here."]} image={IMG.community}
        intro="Shelterease Housing Association provides supported exempt accommodation and personalised support to refugees and vulnerable adults across Coventry." />

      <Section>
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <Overline>Our Story</Overline>
            <Reveal><h2 className="mt-6 font-serif text-4xl tracking-tight text-brand-dark md:text-5xl">Built from lived experience.</h2></Reveal>
            <Reveal delay={0.1}><p className="mt-6 text-lg text-brand-slate">Shelterease was founded by people who have walked the refugee journey themselves. We know what it means to arrive somewhere new, to rebuild from nothing, and to search for a place that feels like home.</p></Reveal>
            <Reveal delay={0.2}><p className="mt-4 text-lg text-brand-slate">That understanding shapes everything we do — from the accommodation we provide to the personalised support that helps residents move towards independent, confident lives.</p></Reveal>
          </div>
          <div className="lg:col-span-6">
            <div className="overflow-hidden rounded-2xl"><img src={IMG.womanChild} alt="Our community" className="h-[28rem] w-full object-cover" /></div>
          </div>
        </div>
      </Section>

      <Section className="bg-brand-surface/60">
        <div className="grid gap-10 md:grid-cols-2">
          {[["Mission", "To provide safe accommodation and personalised support that helps refugees and vulnerable adults rebuild their lives and achieve lasting independence."],
            ["Vision", "A community where everyone — regardless of where they began — has a safe home, a strong future and a genuine sense of belonging."]].map(([t, d]) => (
            <Reveal key={t}><div className="rounded-2xl border border-brand-dark/10 bg-brand-surface p-10">
              <h3 className="font-serif text-3xl text-brand-green">{t}</h3>
              <p className="mt-4 text-brand-slate">{d}</p>
            </div></Reveal>
          ))}
        </div>
      </Section>

      <Section>
        <Overline>Our Values</Overline>
        <Stagger className="mt-10 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {VALUES.map((v) => (
            <StaggerItem key={v.n} className="border-t border-brand-dark/15 pt-6">
              <span className="font-mono-a text-sm text-brand-green">{v.n}</span>
              <h3 className="mt-4 font-serif text-2xl text-brand-dark">{v.title}</h3>
              <p className="mt-3 text-sm text-brand-slate">{v.desc}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </Section>

      <Section className="bg-brand-surface/60">
        <Overline>Meet the Team</Overline>
        <Reveal><h2 className="mt-6 font-serif text-4xl tracking-tight text-brand-dark md:text-5xl">People who care.</h2></Reveal>
        <Stagger className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {TEAM.map((m) => (
            <StaggerItem key={m.name} className="group">
              <div className="overflow-hidden rounded-2xl"><img src={m.img} alt={m.name} className="h-72 w-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
              <h3 className="mt-5 font-serif text-xl text-brand-dark">{m.name}</h3>
              <p className="text-sm text-brand-green">{m.role}</p>
            </StaggerItem>
          ))}
        </Stagger>
        <div className="mt-12"><Btn to="/careers" variant="outline" testid="about-careers-btn">Join our team</Btn></div>
      </Section>
    </>
  );
}
